import angular from 'angular';
import { RootScopeEvents } from './root-scope-types';
export default angular
    .module('doxy.common.services.flipCamera', [])
    .factory('flipCamera', function ($rootScope) {
    return function flipCamera() {
        $rootScope.$emit(RootScopeEvents.USER_ACTIONS.FLIP_CAMERA);
    };
}).name;
